module.exports = __webpack_public_path__ + "static/super-admin-tag-list-3919e9e0f12a77d258a74284b365b7d6.png";